<script>
import { mapGetters } from "vuex";

/**
 * Renders versioned T&C HTML for a (voucherType, voucherDate). The version
 * picked is the highest active version with `effectiveFrom <= voucherDate`,
 * matching the backend rule. This guarantees that an old invoice reprinted
 * today shows the T&C that was active when the invoice was issued.
 *
 * If no matching version exists, the component renders nothing.
 */
export default {
  name: "PrintTermsBlock",
  inject: {
    printVoucherDate: { default: () => () => new Date() },
  },
  props: {
    voucherType: { type: String, required: true },
    title: { type: String, default: "Terms & Conditions" },
  },
  computed: {
    ...mapGetters("printProfile", ["termsFor"]),
    activeTerms() {
      return this.termsFor(this.voucherType, this.printVoucherDate());
    },
  },
};
</script>

<template>
  <section v-if="activeTerms" class="print-terms keep-together">
    <h4 class="print-terms-title">{{ title }}</h4>
    <!-- T&C HTML is authored by company admins via the Print Settings UI;
         it's a trusted source and we render it as HTML for formatting. -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="print-terms-body" v-html="activeTerms.bodyHtml" />
  </section>
</template>

<style scoped>
.print-terms {
  margin-top: 3mm;
  font-size: var(--print-fs-xs);
  line-height: 1.4;
}

.print-terms-title {
  font-size: var(--print-fs-xs);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 1mm;
  color: var(--print-fg);
}

.print-terms-body :deep(p) { margin: 0 0 0.5mm; }
.print-terms-body :deep(ol),
.print-terms-body :deep(ul) {
  margin: 0 0 0.5mm 4mm;
  padding: 0;
}
.print-terms-body :deep(li) {
  margin-bottom: 0.3mm;
}
</style>
